var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDocumentIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2924_21730)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 5.4299H6C5.46957 5.4299 4.96086 5.64061 4.58579 6.01569C4.21071 6.39076 4 6.89947 4 7.4299V19.4299C4 19.9603 4.21071 20.469 4.58579 20.8441C4.96086 21.2192 5.46957 21.4299 6 21.4299H11.697",
    stroke: "#F25C19",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 11.4299V7.4299C18 6.89947 17.7893 6.39076 17.4142 6.01569C17.0391 5.64061 16.5304 5.4299 16 5.4299H14",
    stroke: "#F25C19",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 5.4299C8 4.89947 8.21071 4.39076 8.58579 4.01569C8.96086 3.64061 9.46957 3.4299 10 3.4299H12C12.5304 3.4299 13.0391 3.64061 13.4142 4.01569C13.7893 4.39076 14 4.89947 14 5.4299C14 5.96033 13.7893 6.46904 13.4142 6.84411C13.0391 7.21919 12.5304 7.4299 12 7.4299H10C9.46957 7.4299 8.96086 7.21919 8.58579 6.84411C8.21071 6.46904 8 5.96033 8 5.4299Z",
    stroke: "#F25C19",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3979 21.2474L16.2259 22.3854C16.1614 22.4189 16.0889 22.4339 16.0165 22.4286C15.944 22.4233 15.8744 22.398 15.8155 22.3555C15.7566 22.313 15.7106 22.2549 15.6828 22.1878C15.655 22.1206 15.6464 22.0471 15.6579 21.9754L16.0729 19.5644L14.3159 17.8574C14.2635 17.8067 14.2263 17.7422 14.2087 17.6715C14.1912 17.6007 14.1938 17.5264 14.2165 17.457C14.2391 17.3877 14.2808 17.3261 14.3367 17.2793C14.3927 17.2325 14.4606 17.2024 14.5329 17.1924L16.9609 16.8404L18.0469 14.6474C18.0794 14.582 18.1294 14.5271 18.1914 14.4887C18.2535 14.4503 18.3249 14.4299 18.3979 14.4299C18.4708 14.4299 18.5423 14.4503 18.6043 14.4887C18.6664 14.5271 18.7164 14.582 18.7489 14.6474L19.8349 16.8404L22.2629 17.1924C22.3349 17.2027 22.4026 17.233 22.4583 17.2799C22.5141 17.3267 22.5555 17.3882 22.5781 17.4574C22.6007 17.5266 22.6035 17.6007 22.5861 17.6714C22.5687 17.7421 22.532 17.8065 22.4799 17.8574L20.7229 19.5644L21.1369 21.9744C21.1493 22.0462 21.1413 22.1201 21.1139 22.1877C21.0864 22.2553 21.0405 22.3138 20.9815 22.3566C20.9224 22.3994 20.8526 22.4248 20.7798 22.4299C20.7071 22.4349 20.6343 22.4195 20.5699 22.3854L18.3979 21.2474Z",
    stroke: "#F25C19",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 11.4299H12",
    stroke: "#F25C19",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 15.4299H11",
    stroke: "#F25C19",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2924_21730"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.429901)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentIcon1);
export default __webpack_public_path__ + "static/media/DocumentIcon1.adcbc282f36c6dcf81193aa0ec22c1d5.svg";
export { ForwardRef as ReactComponent };